export const breakpoints = {
  sm: "(max-width: 639px)",
  md: "(max-width: 767px)",
  lg: "(max-width: 1023px)",
  xl: "(max-width: 1279px)",
  "2xl": "(max-width: 1535px)",
}
